import { useDashTrialInfo } from "@mirage/service-dash-trial/hooks/useDashTrialInfo";
import { getDashActionSurface } from "@mirage/shared/hooks/useDashActionSurface";
import { useLocation } from "react-router-dom";
import styles from "./DashTrial.module.css";
import { DashTrialCTAButtonVariant } from "./DashTrialCTA/DashTrialCTAButton";
import { DashTrialIndicatorHome } from "./DashTrialIndicatorHome";
import { DashTrialIndicatorInner } from "./DashTrialIndicatorInner";

export const DashTrialIndicatorTopNav = () => {
  const { daysRemainingInDashTrial, adminName } = useDashTrialInfo();
  const { pathname } = useLocation();
  const surface = getDashActionSurface(pathname);
  if (!surface) {
    return null;
  }

  if (surface === "start_page") {
    return (
      <DashTrialIndicatorHome
        daysLeft={daysRemainingInDashTrial}
        adminName={adminName}
      />
    );
  }

  if (surface === "stacks_page") {
    const variant =
      daysRemainingInDashTrial > 7
        ? DashTrialCTAButtonVariant.SECONDARY
        : DashTrialCTAButtonVariant.PRIMARY;
    return (
      <DashTrialIndicatorInner
        daysLeft={daysRemainingInDashTrial}
        adminName={adminName}
        variant={variant}
        tooltipVariant="withoutTitle"
        tooltipPlacement="bottom-start"
        classNames={{
          container: styles.dashTrialIndicatorContainerStacks,
        }}
      />
    );
  }

  return null;
};
